import http from '@/services/http'
import * as Types from './type'
/**
 * 运单列表
 */
export const getLogisticsList = async (data) => await http.admin.post('/api/order_query/list', data)
/**
 * 运单详情
 */

export const getLogisticsDetail = async (data: Types.QueryTrace) => await http.admin.post<Types.ResOrderDetailType>('/api/order_query/get', data)

/** 轨迹查询 */
export const queryTrace = (params: { logisticsNo: string; appId: string }) => {
  return http.admin.post<Types.ResponseQueryTraceType>('/api/order_query/trace', params)
}

/**
 * 获取面单地址
 */
export const queryBillUrl = (params: Types.WayBillType) => http.admin.post<Types.ResBillType>('/api/order_query/list_way_bill', params)

/**
 * 更新订单打印状态
 */
export const updateWaybillStatus = (logisticsNo: string, appId: string) => http.admin.post('/api/order/update_waybill_status', { logisticsNo, appId })

/** 订单取消 */
export const orderCancel = (data: Types.CancelType) => http.admin.post('/api/order/cancel', data)

/**
 * **接口** [申请面单↗](https://api-doc-sl.inshopline.com/#/project/Java/60/feature%2F20230703_2881_auspost_mypost/interface/8892d9047813e3d4d645652975fa492a)
 * @请求头 `POST /api/order/apply_waybill`
 * @更新时间 `2023-06-30 15:40:01`
 */
export function postApplyWaybill(data: Types.OrderWaybillApplyRequest) {
  return http.admin.post(`/api/order/apply_waybill`, data)
}
